export const customFacetedSearchStyles = {
	facetMenuWrapper: {
		top: "100%"
	},
	facetLabelList: {
		borderRadius: 0
	}
};